import { atom } from "jotai";

export type State = {
  agendaEvent: string;
  agendaEventDate: string;
} | null;

export const plusNewsAgendaAtom = atom<State>(null);
